import { getFromCookie } from './cookie'
import { getParamCaseInsensitive } from './params'
import type { InternauteReconnuForEndpoint } from '@meilleurtaux/form-factory'

export const getInternauteReconnuData = (
  queryParams: URLSearchParams,
): InternauteReconnuForEndpoint | undefined => {
  // Initialisation de la variable
  let internauteData: InternauteReconnuForEndpoint | undefined = undefined
  // On regarde dans les paramètres de l'url
  const internauteReconnuData = getParamCaseInsensitive(queryParams, 'datasClientMTX') ?? undefined
  // Si dans les paramètres de l'url, on remplit la variable
  if (internauteReconnuData) {
    internauteData = { data: internauteReconnuData, fromCookie: false }
  } else {
    const cookieValue = getFromCookie('datasClientMTX') ?? undefined
    if (cookieValue) {
      internauteData = { data: cookieValue, fromCookie: true }
    }
  }
  // On retourne les données de l'internaute reconnu
  return internauteData
}

export const getRedirectUrl = (queryParams: URLSearchParams): string => {
  let redirectUrl = globalThis.location.origin

  queryParams.forEach((value, key) => {
    if (key.toLowerCase() !== 'datasClientMTX'.toLowerCase()) {
      redirectUrl += `${redirectUrl.includes('?') ? '&' : '?'}${key}=${value}`
    }
  })

  return redirectUrl
}
